import { useTranslation } from 'react-i18next'
import { SCREENS } from 'services/Analytics/Analytics'
import type { IncompleteCollageCartItemWarning } from 'stores/cartStore/CartItem'
import { getTileWarningDisplay } from '../cartWarning.config'
import { MissingPhotosPopup } from './MissingPhotosPopup'

export function IncompleteCollagePopup({
  open,
  warning,
  onDismiss,
  onApprove,
}: {
  open: boolean
  warning: IncompleteCollageCartItemWarning
  onDismiss: () => void
  onApprove: () => void
}) {
  const { t } = useTranslation()
  const { labelKey } = getTileWarningDisplay(warning)

  return (
    <MissingPhotosPopup
      open={open}
      popupName="Incomplete Collage"
      thumbnail={null}
      title={t(labelKey)}
      ctaText={t('order.add_photos')}
      analyticsProps={{
        Source: SCREENS.CART_DRAWER,
        'Tile ID': warning.tileId,
      }}
      onDismiss={onDismiss}
      onApprove={onApprove}
    />
  )
}
